import { themeObject } from '../../lib';

export const exportStyles = {
    mainContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        mt: '83px',
        gap: '20px',
    },
    headingTextStyles: {
        fontFamily: 'Raleway',
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '100%',
        color: themeObject.palette.grayScale[700],
    },
    cardContainerStyles: {
        backgroundColor: themeObject.palette.background.default,
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        py: '20px',
        px: '32px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 1,
    },
    containerWidthStyles: {
        width: '100%',
    },
    buttonStyles: {
        width: '489px',
    },
    downloadButtonIconStyles: {
        color: themeObject.palette.primary[600],
    },
    textAndIconContainerStyles: {
        display: 'flex',
        mb: 2,
        mx: '31.5px',
    },
    textContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
    },
    subHeadingTextStyles: {
        ...themeObject.typography.h5,
        lineHeight: '100%',
        color: themeObject.palette.primary[700],
        mt: 1,
    },
    contentTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '100%',
        color: themeObject.palette.primary[700],
        mt: 1,
    },
};

export const downloadFile = (
    fileData: any,
    filename: string,
    contentType: string
): void => {
    let blob = undefined;
    if (filename.endsWith('.json')) {
        if (fileData instanceof ArrayBuffer || fileData instanceof Uint8Array) {
            const decoder = new TextDecoder('utf-8');
            const jsonString = decoder.decode(fileData);
            fileData = JSON.parse(jsonString);
        }
        blob = new Blob(
            [decodeURIComponent(encodeURI(JSON.stringify(fileData)))],
            { type: contentType }
        );
    } else {
        blob = new Blob([fileData], { type: contentType });
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
